import React, { useEffect, useState } from "react";
import {
  getDashboardCountList,
  getTodayDashboardCountList, PieCharData
} from '../../redux/services/dashboardServices/dashboard.Services';
import Chart from "react-apexcharts";
import StaffDashboard from "./StaffDashboard";
import {
  MdDashboard,
  MdWarehouse,
  MdInventory2,
  MdShoppingCart,
  MdPointOfSale,
  MdSwapHoriz,
  MdPeople,
  MdLocalShipping,
  MdTrendingUp,
  MdWarningAmber,
} from "react-icons/md";
import { Link } from "react-router";
const iconMap = {
  dashboard: MdDashboard,
  warehouse: MdWarehouse,
  product: MdInventory2,
  purchase: MdShoppingCart,
  sale: MdPointOfSale,
  transfer: MdSwapHoriz,
  customer: MdPeople,
  supplier: MdLocalShipping,
  revenue: MdTrendingUp,
  lowstock: MdWarningAmber,
};
const Dashboard = () => {
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";
  const adminData = JSON.parse(localStorage.getItem("admin"));
  const [pieChartData, setPieChartData] = useState([]);
  const [summary, setSummary] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('total');
  const [todaySummary, setTodaySummary] = useState({});

  useEffect(() => {
    fetchDashboard();
    fetchTodayDashboard();
    fetchPieChartData();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await getDashboardCountList();
      setSummary(res?.data || {});
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTodayDashboard = async () => {
    try {
      const res = await getTodayDashboardCountList();

      if (res.success) {
        setTodaySummary(res.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPieChartData = async () => {
    try {
      const res = await PieCharData();
      console.log("Pie Chart API:", res);
      setPieChartData(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  const totalTiles = [
    {
      icon: "product",
      label: "Total Products",
      href: "/product-list",
      points: summary?.total_products || 0,
      background: "linear-gradient(135deg,#E3F2FD,#BBDEFB)",
      bordercolor: "#2196F3",
    },
    {
      icon: "warehouse",
      label: "Warehouses",
      href: "/warehouse-list",
      points: summary?.total_warehouses || 0,
      background: "linear-gradient(135deg,#F3E5F5,#E1BEE7)",
      bordercolor: "#9C27B0",
    },
    {
      icon: "purchase",
      label: "Purchases",
      href: "/purchase-list",
      points: summary?.total_purchases || 0,
      background: "linear-gradient(135deg,#FFF8E1,#FFECB3)",
      bordercolor: "#FFC107",
    },
    {
      icon: "sale",
      label: "Sales",
      href: "/sale-list",
      points: summary?.total_sales || 0,
      background: "linear-gradient(135deg,#E8F5E9,#C8E6C9)",
      bordercolor: "#4CAF50",
    },
    {
      icon: "customer",
      label: "Customers",
      href: "/customer-list",
      points: summary?.total_customers || 0,
      background: "linear-gradient(135deg,#E1F5FE,#B3E5FC)",
      bordercolor: "#03A9F4",
    },
    {
      icon: "supplier",
      label: "Suppliers",
      href: "/supplier-list",
      points: summary?.total_suppliers || 0,
      background: "linear-gradient(135deg,#FFF3E0,#FFE0B2)",
      bordercolor: "#FB8C00",
    },
    {
      icon: "transfer",
      label: "Stock Transfers",
      href: "/inventory-transfer-list",
      points: summary?.total_transfers || 0,
      background: "linear-gradient(135deg,#ECEFF1,#CFD8DC)",
      bordercolor: "#607D8B",
    },
    {
      icon: "lowstock",
      label: "Low Stock",
      href: "/low-stock-report",
      points: summary?.low_stock || 0,
      background: "linear-gradient(135deg,#FFEBEE,#FFCDD2)",
      bordercolor: "#E53935",
    },
  ];

  const todayTiles = [
    {
      icon: "purchase",
      label: "Today's Purchases",
      href: "/today-purchase-list",
      points: todaySummary?.today_purchases || 0,
      background: "linear-gradient(135deg,#E3F2FD,#BBDEFB)",
      bordercolor: "#2196F3",
    },
    {
      icon: "sale",
      label: "Today's Sales",
      href: "/today-sale-list",
      points: todaySummary?.today_sales || 0,
      background: "linear-gradient(135deg,#E8F5E9,#C8E6C9)",
      bordercolor: "#4CAF50",
    },
    {
      icon: "transfer",
      label: "Today's Transfers",
      href: "/today-transfer-list",
      points: todaySummary?.today_transfers || 0,
      background: "linear-gradient(135deg,#F3E5F5,#E1BEE7)",
      bordercolor: "#9C27B0",
    },
    {
      icon: "customer",
      label: "New Customers",
      href: "/today-customer-list",
      points: todaySummary?.today_customers || 0,
      background: "linear-gradient(135deg,#FFF8E1,#FFECB3)",
      bordercolor: "#FFC107",
    },
    {
      icon: "supplier",
      label: "New Suppliers",
      href: "/today-supplier-list",
      points: todaySummary?.today_suppliers || 0,
      background: "linear-gradient(135deg,#FFF3E0,#FFE0B2)",
      bordercolor: "#FB8C00",
    },
    {
      icon: "revenue",
      label: "Today's Revenue",
      href: "/today-revenue",
      points: todaySummary?.today_revenue || 0,
      background: "linear-gradient(135deg,#E0F2F1,#B2DFDB)",
      bordercolor: "#009688",
    },
  ];

  const displayedTiles = activeTab === 'total' ? totalTiles : todayTiles;

  const leadSourceOptions = {
    labels: pieChartData.map((item) => item.source),
    legend: {
      position: "bottom",
    },
  };

  const leadSourceSeries =
    pieChartData.length > 0
      ? pieChartData.map((item) => Number(item.total))
      : [];

  const staffOptions = {
    chart: {
      type: "bar",
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
        borderRadius: 4,
      },
    },
    xaxis: {
      categories:
        summary?.summary.monthlySales?.length > 0
          ? summary.summary.monthlySales.map((s) => s.name)
          : ["Rahul", "Amit", "Vikas", "Suresh"],
    },
    legend: {
      position: "bottom",
    },
  };

  const staffSeries = [
    {
      name: "Sales",
      data:
        summary?.monthlySales?.length
          ? summary.monthlySales.map(item => item.sales)
          : []
    },
    {
      name: "Purchase",
      data:
        summary?.monthlySales?.length
          ? summary.monthlySales.map(item => item.purchase)
          : []
    }
  ];

  return (
    <>
      <div className="d-md-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="page-header">
          <div>
            <h3 className="page-title"> Inventory Dashboard</h3>
            <nav className="page-breadcrumb">
              <Link to="/">Home</Link>
              <span className="mx-2">/</span>
              <span>Dashboard </span>
            </nav>
          </div>
        </div>
        <div className="tab-navigation">
          <div className="d-flex gap-2 justify-content-end">
            <button
              className={`tab-btn ${activeTab === 'total' ? 'active' : ''}`}
              onClick={() => setActiveTab('total')}

            >
              Overall Summary
            </button>
            <button
              className={`tab-btn ${activeTab === 'today' ? 'active' : ''}`}
              onClick={() => setActiveTab('today')}
            >
              Today's Summary
            </button>
          </div>
        </div>
      </div>
      <div className="dashboard">
        <div className="row g-4 color_differnt">
          {displayedTiles.map((item, index) => {
            const IconComponent = iconMap[item.icon] || MdDashboard;

            return (
              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3" key={index}>
                <a href={item.href} className="text-decoration-none">
                  <div className="kpi-card" style={{ color: item.bordercolor }}>
                    <div className="kpi-icon" style={{ color: item.bordercolor }}>
                      <IconComponent size={26} />
                    </div>

                    <div className="kpi-content">
                      <h2 className="kpi-value">{item.points}</h2>
                      <p className="kpi-label">{item.label}</p>
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>

        {isAdmin && (
          <>
            <div className="row">
              <div className="col-md-6">
                <div className="chart-panel mt-4">
                  <h5>Sales By Category</h5>
                  <div className="card-body">
                    {leadSourceSeries.length > 0 ? (
                      <Chart
                        options={leadSourceOptions}
                        series={leadSourceSeries}
                        type="pie"
                        height={300}
                      />
                    ) : (
                      <p>No Data Found</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="chart-panel mt-4">
                  <h5>Monthly Sales</h5>
                  <div className="card-body">
                    <Chart
                      options={staffOptions}
                      series={staffSeries}
                      type="bar"
                      height={283}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Dashboard;